import { useCallback, useEffect, useState } from "react";

const KEY = "rincon:favorites";
const EVENT = "rincon:favorites-changed";

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function useFavorites() {
  const [favorites, setFavorites] = useState(read);

  useEffect(() => {
    const sync = () => setFavorites(read());
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const isFavorite = useCallback((id) => favorites.some((f) => f.id === id), [favorites]);

  const toggleFavorite = useCallback((text) => {
    const current = read();
    const exists = current.some((f) => f.id === text.id);
    const next = exists
      ? current.filter((f) => f.id !== text.id)
      : [
          {
            id: text.id,
            title: text.title,
            subcategory: text.subcategory,
            type: text.type,
            main_category: text.main_category,
            created_at: text.created_at,
            epigraph: text.epigraph || null,
          },
          ...current,
        ];
    localStorage.setItem(KEY, JSON.stringify(next));
    window.dispatchEvent(new Event(EVENT));
    return !exists;
  }, []);

  const removeFavorite = useCallback((id) => {
    const next = read().filter((f) => f.id !== id);
    localStorage.setItem(KEY, JSON.stringify(next));
    window.dispatchEvent(new Event(EVENT));
  }, []);

  return { favorites, isFavorite, toggleFavorite, removeFavorite };
}
